import { render, staticRenderFns } from "./GSelectFormInputString.vue?vue&type=template&id=135c8f4d&scoped=true&"
import script from "./GSelectFormInputString.vue?vue&type=script&lang=ts&"
export * from "./GSelectFormInputString.vue?vue&type=script&lang=ts&"
import style0 from "./GSelectFormInputString.vue?vue&type=style&index=0&id=135c8f4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "135c8f4d",
  null
  
)

export default component.exports